import React from 'react'
import PropTypes from 'prop-types'

import SvgIcon from 'Components/SvgIcon'
import { _Title, _SeoText, _SectionHeader } from './styles'

const SectionHeader = ({ className = '', title = '', headerClass = '', headerClassCss = '', secondary, seoText = '',
  headerSize = null, icon = null }) => {
  const HeaderTag = headerSize ? `h${headerSize}` : 'div'
  return (
    <_SectionHeader
      className={className + ' ' + headerClass}
      withSeo={!!seoText}
      secondary={!!secondary}
      customCss={headerClassCss}
    >
      {icon &&
        <SvgIcon name={icon} width={22} height={22} />
      }
      <_Title>
        {title}
      </_Title>
      {
        seoText ? <_SeoText as={HeaderTag}>{seoText}</_SeoText> : ''
      }
    </_SectionHeader>
  )
}


SectionHeader.propTypes = {
  title: PropTypes.string,
  headerClass: PropTypes.string,
  headerClassCss: PropTypes.string,
  className: PropTypes.string,
  seoText: PropTypes.string,
  secondary: PropTypes.bool,
  headerSize: PropTypes.number,
  icon: PropTypes.string,
}
export default SectionHeader
